<template>
  <section class="w-full p-6 md:w-128" data-testid="viewer-merge-video-modal">
    <VideoMergeUpselling v-if="free" class="pt-8" :message="message" header="merge a video" cta="UPGRADE TO PRO" />
    <VideoMergeModalForm v-else />
  </section>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useOrganizationStore } from '@/store/useOrganizationStore';
import VideoMergeUpselling from './VideoMergeUpselling.vue';
import VideoMergeModalForm from './VideoMergeModalForm.vue';

const { free } = storeToRefs(useOrganizationStore());

const message = [
  'Take Your Recordings to the Next Level!',
  'Seamlessly merge your recordings with other videos, allowing you to combine multiple takes or add new scenes.',
  'Save time, enhance creativity, and create more polished content that tells a complete story.',
];
</script>
